export function LocalServer(){
    // return 'http://127.0.0.1:8000/';
    return 'https://acms.akshayakerala.com/';
    // return 'https://akshayakerala.com/';
}